import { oz } from '@weft/utils';
import { HubspotIntegrationConfigurationSchema } from '../hubspot';
import { NetSuiteIntegrationConfigurationSchema } from '../net-suite';
import { StripeIntegrationConfigurationSchema } from '../stripe';

export const IntegrationConfigurationSchema = oz.union([
  NetSuiteIntegrationConfigurationSchema,
  HubspotIntegrationConfigurationSchema,
  StripeIntegrationConfigurationSchema,
]).openapi('IntegrationConfiguration');

export type IntegrationConfiguration = oz.infer<typeof IntegrationConfigurationSchema>;